/**
 * @packageDocumentation
 * @module api.functional.items.reservations
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { ReservationView } from "../../../structures/ReservationView";

/**
 * @controller ReservationController.getReservations
 * @path GET /items/reservations
 * @accessor api.functional.items.reservations.getReservations
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function getReservations(
  connection: IConnection,
): Promise<getReservations.Output> {
  return PlainFetcher.fetch(connection, {
    ...getReservations.METADATA,
    template: getReservations.METADATA.path,
    path: getReservations.path(),
  });
}
export namespace getReservations {
  export type Output = ReservationView[];

  export const METADATA = {
    method: "GET",
    path: "/items/reservations",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = () => "/items/reservations";
}
